import { render, staticRenderFns } from "./port.vue?vue&type=template&id=4f6a10d7&scoped=true"
import script from "./port.vue?vue&type=script&lang=js"
export * from "./port.vue?vue&type=script&lang=js"
import style0 from "./port.vue?vue&type=style&index=0&id=4f6a10d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a10d7",
  null
  
)

export default component.exports